// extracted by mini-css-extract-plugin
export default {"wrapper":"CardView_wrapper__-ph3z"};